// Returns true only when the image reference contains an explicit tag or digest.
// A colon in the registry host:port portion (before the last '/') is NOT a tag.
// Examples:
//   "nginx:latest"              → true  (tag after no slash)
//   "myregistry:9000/myapp"     → false (colon is port, no tag after last '/')
//   "myregistry:9000/myapp:v1"  → true  (colon after last '/' is the tag)
//   "nginx@sha256:abc"          → true  (digest reference)
export function imageHasExplicitTag(image: string): boolean {
  if (image.includes('@')) return true;
  const lastSlash = image.lastIndexOf('/');
  return image.indexOf(':', lastSlash + 1) !== -1;
}
